module.exports = __webpack_public_path__ + "main/assets/public/rrr-50/rrr-horizontal.17769c8c580017e4.svg";